<template>
    <thead class="table-filter">
        <tr>
            <th
                v-for="option in filterOptions"
                :key="option.attribute"
                @click="openSearchbar(option.attribute)"
                :width="option.width"
                class="table-filter__trigger"
                :class="{
                    active: option.attribute === activeAttribute,
                    selected:
                        query[option.attribute] ||
                        (query[option.attribute] === false && query[option.attribute] !== ''),
                    nowrap: option.nowrap,
                }"
            >
                <div>{{ $t(option.translation) }}</div>

                <div
                    class="table-filter__sorting"
                    @click.stop="toggleSorting(option.attribute)"
                    :class="{
                        asc: sorting[option.attribute] === 'asc',
                        desc: sorting[option.attribute] === 'desc',
                    }"
                    v-if="option.attribute"
                >
                    <i class="icon icon--common-caret"></i>
                </div>

                <div class="table-filter__indicator" @click.stop="removeQuery(option.attribute)">
                    <i class="icon icon--common-x"></i>
                </div>
            </th>
            <slot></slot>
        </tr>
        <tr v-for="option in filterOptions" :key="option.attribute">
            <td
                colspan="42"
                class="table-filter__item"
                :class="{ active: activeAttribute === option.attribute }"
            >
                <div class="table-filter__item__inner">
                    <form class="table-filter__mask" @submit.prevent="closeSearchbar">
                        <span class="table-filter__mask__icon">
                            <i class="icon icon--common-search"></i>
                        </span>

                        <span v-if="option.selectable">
                            <label
                                v-for="input in option.selectableOptions"
                                :key="input.translation"
                                class="table-filter__mask__radio"
                            >
                                <input
                                    type="radio"
                                    :value="input.value"
                                    v-model="query[option.attribute]"
                                    @input="$emit('input', query)"
                                    class="table-filter__mask__radio__input"
                                />
                                <span class="capitalize">{{ $t(input.translation) }}</span>
                            </label>
                        </span>
                        <span v-if="!option.selectable">
                            <input
                                :ref="'input_' + option.attribute"
                                type="search"
                                class="table-filter__mask__input"
                                autocomplete="off"
                                placeholder="Suche"
                                v-model="query[option.attribute]"
                                @input="$emit('input', query)"
                            />
                        </span>
                    </form>

                    <div class="table-filter__background" @click="closeSearchbar"></div>
                </div>
            </td>
        </tr>
    </thead>
</template>

<script>
export default {
    props: {
        filterOptions: Array,
    },
    data() {
        return {
            activeAttribute: '',
            query: {},
            sorting: {},
        };
    },
    methods: {
        openSearchbar(attr) {
            if (attr) {
                if (this.activeAttribute === attr) {
                    this.closeSearchbar();
                } else {
                    this.activeAttribute = attr;

                    window.setTimeout(() => {
                        this.focusInput(attr);
                    }, 300);
                }
            }
        },
        closeSearchbar() {
            this.activeAttribute = '';
        },
        removeQuery(attr) {
            this.query[attr] = '';
        },
        toggleSorting(attr) {
            if (this.sorting[attr] === 'asc') {
                this.sorting = {};
                this.sorting[attr] = 'desc';
            } else {
                this.sorting = {};
                this.sorting[attr] = 'asc';
            }
            this.$emit('sorting', this.sorting);
        },
        focusInput(attr) {
            let input = this.$refs['input_' + attr];

            if (input instanceof Array) {
                input = input[0];
            }

            if (input && typeof input.focus === 'function') {
                input.focus();
            }
        },
    },
};
</script>
